import * as React from 'react';

import Grid from '@mui/material/Grid';
import useMediaQuery from '@mui/material/useMediaQuery';

interface IProps {
  size: number;
  children: React.ReactNode;
}

function Carousel(props: IProps) {
  const isExtraSmallScreen = useMediaQuery('(max-width:740px)');
  const isMediumScreen = useMediaQuery('(max-width:1400px)');

  const { children } = props;
  let size = props.size;

  // change size based on screen size
  if (isExtraSmallScreen) {
    size = 1;
  } else if (isMediumScreen) {
    size = 2;
  }

  const childrenArray = React.Children.toArray(children);
  const [currentIndex, setCurrentIndex] = React.useState(0);

  const previous = () => {
    setCurrentIndex((prevIndex) => Math.max(0, prevIndex - 1));
  };

  const next = () => {
    const maxStartIndex = Math.max(0, childrenArray.length - size);
    setCurrentIndex((prevIndex) => Math.min(maxStartIndex, prevIndex + 1));
  };

  const maxStartIndex = Math.max(0, childrenArray.length - size);

  return (
    <Grid item={true} xs={10} lg={8} className={'carousel-container'}>
      {/* <div className="carousel-items-wrapper" style={{ left: `-${currentIndex * (100 / size)}%` }}> */}
      <div className="carousel-items-wrapper" style={{ left: `-${currentIndex * 330}px` }}>
        {childrenArray.map((child, index) => (
          <div key={index} className="carousel-item">
            {child}
          </div>
        ))}
      </div>
      <div className="carousel-buttons-container">
        <button
          onClick={previous}
          disabled={currentIndex === 0}
          className="carousel-buttons-container-left"
          data-qa="carousel-button-left"
        />
        <button
          onClick={next}
          disabled={currentIndex === maxStartIndex}
          className="carousel-buttons-container-right"
          data-qa="carousel-button-right"
        />
      </div>
    </Grid>
  );
}

export { Carousel };
